export default __webpack_public_path__ + "static/MobileApp-04137bde87a05ba22ef3ab604a504969.png";